import { IntegrationConfig, IntegrationConfigResponse } from './types';

export const transformIntegrationConfig = (integrationConfig: IntegrationConfigResponse) => ({
  venueId: integrationConfig.venue_id,
  integratorId: integrationConfig.integrator_id,
  enabledIntegrationTypes: integrationConfig.enabled_integration_types.reduce(
    (acc, type) => ({ ...acc, [type]: true }),
    {} as IntegrationConfig['enabledIntegrationTypes'],
  ),
});
